export default __webpack_public_path__ + "static/media/Espresso_Machine.e4505cfd.png";